import {Category, Unit, Vat} from '../../../../_metronic/helpers'

export type Product = {
  id: number
  code: string
  reference: string
  label: string
  description?: string
  price: number
  quantity: number
  category: Category
  categoryId?: number
  unit: Unit
  color?: string
  tva?: Vat
  tva_2: Vat
  minStock: number
  maxStock: number
  allowManufactureEmpty: boolean
  isArchived: boolean
  createdAt: string
  updatedAt: string
  sellPrice: number
  typeProductId: number
  priceType: number
  sellPriceType: number
  currency: string
  buyingTva?: number
  buyingTvaTwo?: number
  buyingTvaThree?: number
  sellingTva?: number
  sellingTvaTwo?: number
  sellingTvaThree?: number
  barCode?: string
}

export type ProductFormData = {
  code: string
  label: string
  description?: string
  price?: number
  minStock?: number
  maxStock?: number
  category?: Category
  categoryId?: number
  unit?: number
  color?: string
  tva?: number
  tva_2?: number
  allowManufactureEmpty: boolean
  sellPrice?: number
  typeProductId?: number
  priceType?: number
  sellPriceType?: number
  currency?: string
  buyingTva?: number
  buyingTvaTwo?: number
  buyingTvaThree?: number
  sellingTva?: number
  sellingTvaTwo?: number
  sellingTvaThree?: number
  barCode?: string
}

const initValues: ProductFormData = {
  code: '',
  label: '',
  color: '',
  minStock: 0,
  maxStock: 0,
  category: undefined,
  categoryId: undefined,
  barCode: undefined,
  unit: undefined,
  allowManufactureEmpty: false,
}

export type Color = {
  id: number
  label: string
  hexCode: string
}

interface CommonAttributes {
  id: number
  label: string
  color?: Color
}

export type Fabric = CommonAttributes
export type Closure = CommonAttributes
export type Sleeve = CommonAttributes

export {initValues}
